'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function UAFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-1t6wtebzg", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-timwia3jf", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-r7vuawn70" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-r7vuawn70", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-1t6wtebzg)" }, /* @__PURE__ */ React.createElement("use", { fill: "#3195f9", xlinkHref: "#mantine-r7vuawn70" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M0 12h32v12H0z", mask: "url(#mantine-timwia3jf)" })))
  );
}

export { UAFlag };
//# sourceMappingURL=UA.mjs.map
